<template>
  <div class="metadata">
    <ul class="metadata-list">
      <template v-if="isMovie">
        <li v-if="year">{{ year }}</li>
        <li v-if="playTime">{{ playTime }}</li>
      </template>

      <template v-else>
        <li v-if="hasSeason">{{ `시즌 ${Number(seasonList) || '1'}개` }}</li>
      </template>

      <li v-if="targetAge">
        <AgeGrade :target-age="targetAge" :section="kmrbCode" />
      </li>
      <li v-if="genreText">{{ genreText }}</li>
    </ul>
    <ul class="tag-list">
      <li v-if="isCC">
        <img
          :src="require('@/assets/images/detail/ico_badges_cc.png')"
          alt="cc 아이콘"
        />
      </li>
      <li v-if="videoSpec">
        <img
          :src="require(`@/assets/images/detail/ico_badges_${videoSpec}.png`)"
          :alt="`${videoSpec} 아이콘`"
        />
      </li>
    </ul>
  </div>
</template>
<script setup>
  import { computed, defineProps } from 'vue'
  import { getVideoSpec } from '@/common/util/player.util'
  import AgeGrade from '@/components/play/AgeGrade'

  const props = defineProps({
    contentInfo: {
      type: Object,
      default: null,
    },
    contentType: {
      type: String,
      default: '',
    },
  })

  const isMovie = computed(() => props.contentType === 'movie')

  const movieGenre = computed(
    () => props.contentInfo?.genre?.list[0]?.text || '',
  )
  const vodGenre = computed(() => props.contentInfo?.genretext || '')

  const genreText = computed(() =>
    isMovie.value ? movieGenre.value : vodGenre.value,
  )
  const isCC = computed(
    () => props.contentInfo?.isCC?.toLowerCase() === 'y' || false,
  )
  const kmrbCode = computed(() => {
    const { kmrbcode = '' } = props.contentInfo
    return kmrbcode ? 'movie' : 'vod'
  })
  const playTime = computed(() => {
    const _playTime = props.contentInfo?.playtime || ''
    return `${Math.floor(Number(_playTime) / 60)}분`
  })
  const seasonList = computed(
    () => props.contentInfo?.season_list?.count || '0',
  )
  const targetAge = computed(() => props.contentInfo?.targetage || '')
  const year = computed(() => props.contentInfo?.originalreleaseyear || '')

  const hasSeason = computed(() => Number(seasonList.value) >= 1)
  const videoSpec = computed(() => getVideoSpec(props.contentInfo))
</script>
